import { useTranslation } from 'react-i18next';
import { Form, FormInstance, Input, Modal } from 'antd';
import { useState } from 'react';
import showNotification from '../notification';
import { DefaultGUID } from '../../../constants/app-constants';
import { CheckPasswordModel } from '@/models/user';
import { UserApi } from '@/apis/user.api';
import "./index.scss";
interface InsertPasscodeFormProps {
  formSubmit: FormInstance<any> | undefined;
  visible: boolean;
  onClose: (isReload: boolean) => void;
  onCallBack?: (recordId?: string) => void;
  usingcase?: string;
  isLoading?: boolean;
}

export function InsertPasscodeForm(props: InsertPasscodeFormProps) {
  const { t } = useTranslation();
  const [passcodeForm] = Form.useForm();
  const [isLoadingModal, setLoadingModal] = useState(false);

  const handleOk = () => {
    passcodeForm.submit();
  };

  const handleCancel = () => {
    passcodeForm.resetFields();
    props.onClose(true);
  };

  async function handleSubmitMFA(values: any) {
    setLoadingModal(true);
    try {
      if (props.usingcase === 'check-password') {
        const model: CheckPasswordModel = {
          password: values.adminPasscode,
        };
        await UserApi.checkUserPassword(model);
        const recordId = props.formSubmit?.getFieldValue('recordId') ?? DefaultGUID;
        props.onClose(false);
        if (props.onCallBack !== undefined)
          props.onCallBack(recordId);

      } else {
        props.formSubmit?.setFieldValue('adminPasscode', values.adminPasscode);
        props.formSubmit?.submit();
      }
    } catch (error) {
      showNotification("error", t('verify.invalid_password'));
    } finally {
      passcodeForm.resetFields();
      setLoadingModal(false);
    }
  }

  return (
    <Modal
      className="modal-confirm"
      title={t('verify.ModalInsertPasswordTitle')}
      open={props.visible}
      okText="Confirm"
      okButtonProps={{ loading: props.isLoading != null ? props.isLoading : isLoadingModal}}
      onOk={handleOk}
      onCancel={handleCancel}>
      <Form
        className="modal-container"
        layout="vertical"
        labelWrap
        form={passcodeForm}
        onFinish={handleSubmitMFA}>
        <Form.Item
          name="adminPasscode"
          label={t('verify.ModalInsertPasscord')}
          hasFeedback
          rules={[{ required: true, message: 'Password is required.' }]}>
          <Input.Password
            className="input-base"
            placeholder={t('user.yourPasscode')}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default InsertPasscodeForm;
